import { render, staticRenderFns } from "./load-fail.vue?vue&type=template&id=f7a9b8b4&scoped=true&"
import script from "./load-fail.vue?vue&type=script&lang=ts&"
export * from "./load-fail.vue?vue&type=script&lang=ts&"
import style0 from "./load-fail.vue?vue&type=style&index=0&id=f7a9b8b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a9b8b4",
  null
  
)

export default component.exports